import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import FloatingCTAs from './components/FloatingCTAs'
import ScrollToTop from './components/ScrollToTop'

import Home from './pages/Home'
import PrivateCleaning from './pages/PrivateCleaning'
import CommercialCleaning from './pages/CommercialCleaning'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#FAF9F5] text-[#1B241E] font-sans antialiased pb-16 md:pb-0">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privat-rengoering" element={<PrivateCleaning />} />
            <Route path="/erhvervsrengoering" element={<CommercialCleaning />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTAs />
      </div>
    </>
  )
}
